// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { getStationOptionList } from '../../selectors/shared';
import { addProperty } from '../../redux/reducers/property';
import { loadStations } from '../../redux/reducers/stations';

import Loader from '../../components/Loader/Loader';
import FormWrapper from '../../components/shared/FormWrapper';
import PropertyNav from '../../components/shared/PropertyNav';
import PropertyLocationForm from '../../components/PropertyForms/PropertyLocationForm';

class PropertyAdd extends Component {
    onSubmit: Function;

    constructor(props) {
        super(props);

        this.onSubmit = this.onSubmit.bind(this);
    }

    componentDidMount() {
        this.props.dispatch(loadStations(1, 9999));
    }

    onSubmit(formValues) {
        const { history } = this.props;

        const property = {
            propertyReference: formValues.reference,
            propertyStatus: 'HIDE',
            propertyName: formValues.name,
            propertyAddress: formValues.address,
            propertyTown: formValues.townCity,
            propertyPostCode: formValues.postcode,
            propertyBusinessEstateId: formValues.businessEstateId,
            propertyStationId: formValues.nearestStationId,
            propertyRegionId: formValues.regionId,
            propertyCountyId: formValues.countyId,
            propertyBoroughId: formValues.boroughId,
            propertyLat: formValues.geolocation
                ? formValues.geolocation.lat
                : null,
            propertyLong: formValues.geolocation
                ? formValues.geolocation.lng
                : null,
        };

        this.props.dispatch(addProperty(property)).then(newProperty => {
            history.push(
                `/property/edit/${newProperty.propertyReference}/description`
            );
        });
    }

    render() {
        const {
            boroughs,
            businessEstates,
            counties,
            regions,
            stationOptions,
            fetchingStations,
        } = this.props;

        return (
            <FormWrapper>
                <PropertyNav mode="add" />

                {fetchingStations &&
                    <Loader message="Loading, please wait..." />}

                {!fetchingStations &&
                    <PropertyLocationForm
                        boroughs={boroughs}
                        businessEstates={businessEstates}
                        counties={counties}
                        onSubmit={this.onSubmit}
                        regions={regions}
                        stationOptions={stationOptions}
                    />}
            </FormWrapper>
        );
    }
}

const mapStateToProps = state => {
    const shared = state.shared;

    return {
        boroughs: shared.boroughs,
        businessEstates: shared.businessEstates,
        counties: shared.counties,
        regions: shared.regions,
        stationOptions: getStationOptionList(state),
        fetchingStations: state.stations.list.fetching,
    };
};

export default withRouter(connect(mapStateToProps)(PropertyAdd));



// WEBPACK FOOTER //
// ./src/containers/PropertyAdd/PropertyAdd.js